import React, { useState, useEffect } from 'react';
import { NavLink, useParams, useNavigate} from 'react-router-dom';
import DatosCabezaFamilia from '../Caracterizacion/DatosCabezaFamilia.jsx';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from './../../Auth/apiService.jsx';
import MenuCaracterizacion from '../Caracterizacion/Componentes/MenuCaracterizacion.jsx';
import ButtonsMenu from '../Utils/ButtonsMenu.jsx';
import { useAuth } from './../../Auth/AuthContext.jsx';
import SearchForm from './../Utils/Searchform.jsx';
import { FaFile } from 'react-icons/fa';
import { BotonBorrar } from './../Utils/BotonBorrar.jsx';
import { savePermisosPaginas, getPermisosPaginas } from './../Utils/indexedDBUtils';

export default function RegistroAtenciones(){
    const navigate = useNavigate();
    const { token, rol, user, fetchPermisosPaginas } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const [swalProps, setSwalProps] = useState();
    const [atenciones, setAtenciones] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [permisosPaginas, setPermisosPaginas] = useState([]);
    const consultarPermisosPaginas = React.useCallback(async () => {
        const cachedPermisos = await getPermisosPaginas();
        if (cachedPermisos) {
            setPermisosPaginas(cachedPermisos);
        } else {
            // If not in IndexedDB, fetch from the API
            const permisos = await fetchPermisosPaginas();
            if (permisos) {
                setPermisosPaginas(permisos);
                await savePermisosPaginas(permisos); // Save the result to IndexedDB
            }
        }
    }, [fetchPermisosPaginas]);
    useEffect(() => {
        consultarPermisosPaginas();
    }, [consultarPermisosPaginas]);
    const handleSearch = (event) => {
        event.preventDefault();
        if (searchTerm.trim() !== '') {
            navigate(`/ddhh/registroatenciones/${searchTerm}`, { replace: true });
            fetchData(searchTerm, rol);
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
            didClose: () => {
                setSwalProps({});
            },
        });
    };
    const fetchData = async (idCabezaFamilia, rol) => {
        const url = '/ddhh/atencionsddhh/listarregistroatenciones';
        const obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol }
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            if(result.cabezafamilia){
                setCabezaFamiliaDatos(result.cabezafamilia);
            
            }
            setAtenciones(result.atenciones);
        } catch (error) {
            console.error('Error fetching data:', error);
            Mensaje('Atenciones', `Hubo un error con la carga de datos con el documento ${idCabezaFamilia}`);
        } finally {
            setCargando(false);
        }
    };
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        fetchData(idCabezaFamilia, rol);
    }, []);
    async function handleDelete (row){
        const confirmDelete = await mensajeEliminar("Eliminar Atención", "¿Está seguro de que desea eliminar esta atención?");
        if (!confirmDelete) {
            return;
        }
        const url = '/ddhh/atencionsddhh/eliminarregistroatencion';
        const obj = {idDetalleAtencion: row.id, idUsuario: user}
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                Mensaje('Atenciones', response.data.message);
                await fetchData(idCabezaFamilia, rol);
            } else {
                Mensaje('Atenciones', 'Hubo un error al eliminar la atención');
            }
        } catch (error) {
            if (error.response?.data) {
                Mensaje('Atenciones', `Hubo un error al eliminar la atención: ${error.response.data}`);
            } else {
                Mensaje('Atenciones', `Hubo un error al eliminar la atención: ${error}`);
            }
        }
    };
    function mensajeEliminar(title, text) {
        return new Promise((resolve) => {
            let confirmoEliminacion = false;
            setSwalProps({
            show: true,
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                confirmoEliminacion = true;
            },
            didClose: () => {
                setSwalProps({});
                resolve(confirmoEliminacion);
            },
            });
        });
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Registro de atenciones del hogar</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                                {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                                <li className="breadcrumb-item active"> Atenciones</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                    </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <DatosCabezaFamilia datos={CabezaFamiliaDatos} />
                    <SearchForm searchTerm={searchTerm} setSearchTerm={setSearchTerm} handleSearch={handleSearch} Cargando={Cargando} />
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className='card-body'>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <ButtonsMenu data={atenciones} />
                                            </div>
                                            <div className="col-md-6 text-end">
                                                <NavLink to={`/ddhh/atencionddhh/${idCabezaFamilia}`}>
                                                    <button type="button" className="btn btn-primary">
                                                        <FaFile/> Registrar atencion
                                                    </button>
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>Acciones</th>
                                            <th>Id atención</th>
                                            <th>Tipo ayuda</th>
                                            <th>Integrante</th>
                                            <th>Sede</th>
                                            <th>Tipo de atención</th>
                                            <th>Entidad</th>
                                            <th>Fecha</th>
                                            <th>Obsevaciones</th>
                                            <th>Creadopor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {atenciones.length === 0 ? (
                                            <tr>
                                                <td colSpan="10" className="text-center">
                                                    No hay datos para mostrar
                                                </td>
                                            </tr>
                                        ) : (
                                            atenciones.map((row, idx) => (
                                                <tr key={row.id || idx}>
                                                    <td>
                                                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                                                            {rol === '2' && <BotonBorrar Borrar={handleDelete} row={row} />}
                                                        </div>
                                                    </td>
                                                    <td>{row.id}</td>
                                                    <td>{row.tipoayuda}</td>
                                                    <td style={{ whiteSpace: 'pre-line', wordBreak: 'break-word'}}>{row.integrante}</td>
                                                    <td>{row.sede}</td>
                                                    <td>{row.atencion}</td>
                                                    <td>{row.entidad}</td>
                                                    <td>{row.fecha ? row.fecha.split("T")[0] : ''}</td>
                                                    <td style={{ whiteSpace: 'pre-line', wordBreak: 'break-word'}}>
                                                        {row.observaciones}
                                                    </td>
                                                    <td style={{ whiteSpace: 'pre-line', wordBreak: 'break-word'}}>{row.usrnombre}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <SweetAlert2 {...swalProps} />
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}